// extracted by mini-css-extract-plugin
export var icon = "_47-1";
export var subtext = "_47-0";